<script>
import { assetURL, baseURL } from '../../../utils/url';

export default {
    data() {
        return {
            fileUpload: `${assetURL}images/contact/file-uploaded.png`,
            imageUpload: `${assetURL}images/contact/image-uploaded.png`,
            noFileUpload: `${assetURL}images/contact/no-file-uploaded.png`,
            noImageUpload: `${assetURL}images/contact/no-image-uploaded.png`,
            uploadFailed: `${assetURL}images/contact/upload-failed.png`,
        };
    },
};
</script>
<template>
    <div id="formStep3">
        <div class="mb-30px">
            <h3 class="fs-24px tw-text-darkGreen">
                Let's get your documents sorted.
            </h3>
            <p class="fs-16px fw-medium tw-text-black">
                Submit your documents on JPG, PNG, PDF formats not larger than
                10mb.
            </p>
        </div>
        <form id="formStep2">
            <div class="row">
                <div class="col-12 col-xxl-6">
                    <div class="tw-flex tw-flex-col lg:tw-flex-row">
                        <div class="tw-w-[33%] md:tw-w-[20%] lg:tw-w-[20%]">
                            <img :src="noImageUpload" class="tw-w-full" />
                        </div>
                        <div class="tw-w-full lg:tw-w-[80%] tw-pl-3">
                            <div class="form-group">
                                <label
                                    class="fs-16px fw-medium tw-text-black"
                                    for="#selfphoto"
                                    >Photo of yourself
                                    <span class="tw-text-red">*</span></label
                                >
                                <input
                                    type="file"
                                    name="selfphoto"
                                    id="selfphoto"
                                />
                                <p
                                    class="fs-16px fw-medium tw-text-black tw-mb-0"
                                >
                                    Submit a clear color photo of your face,
                                    without the use of filters, preferably taken
                                    in the 6 months. Must be in JPG or PNG
                                    format.
                                </p>
                                <div class="tw-text-red">
                                    <svg
                                        id="Group_5488"
                                        data-name="Group 5488"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            id="Path_3775"
                                            data-name="Path 3775"
                                            d="M0,0H16V16H0Z"
                                            fill="none"
                                        />
                                        <path
                                            id="Path_3776"
                                            data-name="Path 3776"
                                            d="M12,9v1.333M12,13v.007"
                                            transform="translate(-4 -3)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                        <path
                                            id="Path_3777"
                                            data-name="Path 3777"
                                            d="M4.331,13.656h9.333a1.333,1.333,0,0,0,1.227-1.833L10.158,3.656a1.333,1.333,0,0,0-2.333,0L3.091,11.823a1.333,1.333,0,0,0,1.167,1.833"
                                            transform="translate(-0.998 -0.989)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                    Please upload a valid file.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xxl-6">
                    <div class="tw-flex tw-flex-col lg:tw-flex-row">
                        <div class="tw-w-[33%] md:tw-w-[20%] lg:tw-w-[20%]">
                            <img :src="noImageUpload" class="tw-w-full" />
                        </div>
                        <div class="tw-w-full lg:tw-w-[80%] tw-pl-3">
                            <div class="form-group">
                                <label
                                    class="fs-16px fw-medium tw-text-black"
                                    for="#valid_id_1"
                                    >Valid ID
                                    <span class="tw-text-red">*</span></label
                                >
                                <input
                                    type="file"
                                    name="valid_id_1"
                                    id="valid_id_1"
                                />
                                <p
                                    class="fs-16px fw-medium tw-text-black tw-mb-0"
                                >
                                    Provide samples and description to aid the
                                    user. Lorem ipsum
                                </p>
                                <div class="tw-text-red">
                                    <svg
                                        id="Group_5488"
                                        data-name="Group 5488"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            id="Path_3775"
                                            data-name="Path 3775"
                                            d="M0,0H16V16H0Z"
                                            fill="none"
                                        />
                                        <path
                                            id="Path_3776"
                                            data-name="Path 3776"
                                            d="M12,9v1.333M12,13v.007"
                                            transform="translate(-4 -3)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                        <path
                                            id="Path_3777"
                                            data-name="Path 3777"
                                            d="M4.331,13.656h9.333a1.333,1.333,0,0,0,1.227-1.833L10.158,3.656a1.333,1.333,0,0,0-2.333,0L3.091,11.823a1.333,1.333,0,0,0,1.167,1.833"
                                            transform="translate(-0.998 -0.989)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                    Please upload a valid file.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xxl-6">
                    <div class="tw-flex tw-flex-col lg:tw-flex-row">
                        <div class="tw-w-[33%] md:tw-w-[20%] lg:tw-w-[20%]">
                            <img :src="noImageUpload" class="tw-w-full" />
                        </div>
                        <div class="tw-w-full lg:tw-w-[80%] tw-pl-3">
                            <div class="form-group">
                                <label
                                    class="fs-16px fw-medium tw-text-black"
                                    for="#valid_id_2"
                                    >Valid ID
                                    <span class="tw-text-red">*</span></label
                                >
                                <input
                                    type="file"
                                    name="valid_id_2"
                                    id="valid_id_2"
                                />
                                <p
                                    class="fs-16px fw-medium tw-text-black tw-mb-0"
                                >
                                    Provide samples and description to aid the
                                    user. Lorem ipsum
                                </p>
                                <div class="tw-text-red">
                                    <svg
                                        id="Group_5488"
                                        data-name="Group 5488"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            id="Path_3775"
                                            data-name="Path 3775"
                                            d="M0,0H16V16H0Z"
                                            fill="none"
                                        />
                                        <path
                                            id="Path_3776"
                                            data-name="Path 3776"
                                            d="M12,9v1.333M12,13v.007"
                                            transform="translate(-4 -3)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                        <path
                                            id="Path_3777"
                                            data-name="Path 3777"
                                            d="M4.331,13.656h9.333a1.333,1.333,0,0,0,1.227-1.833L10.158,3.656a1.333,1.333,0,0,0-2.333,0L3.091,11.823a1.333,1.333,0,0,0,1.167,1.833"
                                            transform="translate(-0.998 -0.989)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                    Please upload a valid file.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xxl-6">
                    <div class="tw-flex tw-flex-col lg:tw-flex-row">
                        <div class="tw-w-[33%] md:tw-w-[20%] lg:tw-w-[20%]">
                            <img :src="noFileUpload" class="tw-w-full" />
                        </div>
                        <div class="tw-w-full lg:tw-w-[80%] tw-pl-3">
                            <div class="form-group">
                                <label
                                    class="fs-16px fw-medium tw-text-black"
                                    for="#billing_statement"
                                    >Billing statement
                                    <span class="tw-text-red">*</span></label
                                >
                                <input
                                    type="file"
                                    name="billing_statement"
                                    id="billing_statement"
                                />
                                <p
                                    class="fs-16px fw-medium tw-text-black tw-mb-0"
                                >
                                    Provide samples and description to aid the
                                    user. Lorem ipsum
                                </p>
                                <div class="tw-text-red">
                                    <svg
                                        id="Group_5488"
                                        data-name="Group 5488"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            id="Path_3775"
                                            data-name="Path 3775"
                                            d="M0,0H16V16H0Z"
                                            fill="none"
                                        />
                                        <path
                                            id="Path_3776"
                                            data-name="Path 3776"
                                            d="M12,9v1.333M12,13v.007"
                                            transform="translate(-4 -3)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                        <path
                                            id="Path_3777"
                                            data-name="Path 3777"
                                            d="M4.331,13.656h9.333a1.333,1.333,0,0,0,1.227-1.833L10.158,3.656a1.333,1.333,0,0,0-2.333,0L3.091,11.823a1.333,1.333,0,0,0,1.167,1.833"
                                            transform="translate(-0.998 -0.989)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                    Please upload a valid file.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xxl-6">
                    <div class="tw-flex tw-flex-col lg:tw-flex-row">
                        <div class="tw-w-[33%] md:tw-w-[20%] lg:tw-w-[20%]">
                            <img :src="noFileUpload" class="tw-w-full" />
                        </div>
                        <div class="tw-w-full lg:tw-w-[80%] tw-pl-3">
                            <div class="form-group">
                                <label
                                    class="fs-16px fw-medium tw-text-black"
                                    for="#proof_of_income"
                                    >Proof of income<span class="tw-text-red"
                                        >*</span
                                    ></label
                                >
                                <input
                                    type="file"
                                    name="proof_of_income"
                                    id="proof_of_income"
                                />
                                <p
                                    class="fs-16px fw-medium tw-text-black tw-mb-0"
                                >
                                    Provide samples and description to aid the
                                    user. Lorem ipsum
                                </p>
                                <div class="tw-text-red">
                                    <svg
                                        id="Group_5488"
                                        data-name="Group 5488"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            id="Path_3775"
                                            data-name="Path 3775"
                                            d="M0,0H16V16H0Z"
                                            fill="none"
                                        />
                                        <path
                                            id="Path_3776"
                                            data-name="Path 3776"
                                            d="M12,9v1.333M12,13v.007"
                                            transform="translate(-4 -3)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                        <path
                                            id="Path_3777"
                                            data-name="Path 3777"
                                            d="M4.331,13.656h9.333a1.333,1.333,0,0,0,1.227-1.833L10.158,3.656a1.333,1.333,0,0,0-2.333,0L3.091,11.823a1.333,1.333,0,0,0,1.167,1.833"
                                            transform="translate(-0.998 -0.989)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                    Please upload a valid file.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xxl-6">
                    <div class="tw-flex tw-flex-col lg:tw-flex-row">
                        <div class="tw-w-[33%] md:tw-w-[20%] lg:tw-w-[20%]">
                            <img :src="noFileUpload" class="tw-w-full" />
                        </div>
                        <div class="tw-w-full lg:tw-w-[80%] tw-pl-3">
                            <div class="form-group">
                                <label
                                    class="fs-16px fw-medium tw-text-black"
                                    for="#other_document"
                                    >Other document<span class="tw-text-red"
                                        >*</span
                                    ></label
                                >
                                <input
                                    type="file"
                                    name="other_document"
                                    id="other_document"
                                />
                                <p
                                    class="fs-16px fw-medium tw-text-black tw-mb-0"
                                >
                                    Provide samples and description to aid the
                                    user. Lorem ipsum
                                </p>
                                <div class="tw-text-red">
                                    <svg
                                        id="Group_5488"
                                        data-name="Group 5488"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            id="Path_3775"
                                            data-name="Path 3775"
                                            d="M0,0H16V16H0Z"
                                            fill="none"
                                        />
                                        <path
                                            id="Path_3776"
                                            data-name="Path 3776"
                                            d="M12,9v1.333M12,13v.007"
                                            transform="translate(-4 -3)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                        <path
                                            id="Path_3777"
                                            data-name="Path 3777"
                                            d="M4.331,13.656h9.333a1.333,1.333,0,0,0,1.227-1.833L10.158,3.656a1.333,1.333,0,0,0-2.333,0L3.091,11.823a1.333,1.333,0,0,0,1.167,1.833"
                                            transform="translate(-0.998 -0.989)"
                                            fill="none"
                                            stroke="#ef476f"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                    Please upload a valid file.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
